export class TicketNotificationData {
  TicketNumber: string;
  TicketDesignation: string;
  TicketPriority: string;
  TicketTaskDesignation: string;
  TicketTaskResourceLogin: string;

  constructor(data: any) {
    Object.assign(this, data);
  }
}
